import Header from "../Global/Header";
import Stakecards from "./Stakecards";
export default function Stake() {
  return (
    <>
      <div className="background_stake">
        <Header />

        <div className="container stakes">
          <div className="row row_stake">
            <div className="col-sm-3 box_list1">
              <div className="box_1 rewards">
                <p>REWARDS per day</p>
                <p>
                  <span>1200</span>
                </p>
              </div>
            </div>
            <div className="col-sm-3 box_list2">
              <div className="box_2 rewards">
                <p>Total claimed $LITTLE</p>
                <p>
                  <span>5.930,09</span>
                </p>
              </div>
            </div>
            <div className="col-sm-3 box_list3">
              <div className="box_3 rewards">
                <p>STAKED LITTLE BILLIONAIERS</p>
                <p>
                  <span>03</span>
                </p>
              </div>
            </div>
            <div className="col-sm-3 box_list4">
              <div className="box_4 rewards">
                <p>$LITTLE BALANCE</p>
                <p>
                  <span>2.250,09</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container stakes">
          <div className="row">
            <Stakecards />
          </div>
        </div>
      </div>
    </>
  );
}
